import Browser from "../browser.js";

export default class PageBrowser
{
    constructor()
    {
        this.browser = new Browser();
        this.browser.doBrowserTest();
    }
}
